import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const payoutSection = "/payouts/";

export const payoutListPath = payoutSection;
export const payoutListUrl = (params?: { status?: string }) =>
  payoutListPath + (params ? "?" + stringifyQs(params) : "");

export const payoutPath = (id: string) => urlJoin(payoutSection, id);
export const payoutUrl = (id: string) => payoutPath(encodeURIComponent(id));
